import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ProgressContext = createContext(null);

export const ProgressProvider = ({ children }) => {
  const [progressMessage, setProgressMessage] = useState('Ready.');
  const [progressDetails, setProgressDetails] = useState('');
  const [progressVisible, setProgressVisible] = useState(false);

  const showProgress = useCallback((message, details) => {
    setProgressMessage(message);
    if (details) setProgressDetails(details);
    setProgressVisible(true);
  }, []);

  const hideProgress = useCallback(() => {
    setProgressMessage('Ready.');
    setProgressDetails('');
    setProgressVisible(false);
  }, []);

  const value = useMemo(() => ({
    progressVisible,
    progressMessage,
    progressDetails,
    setProgressMessage,
    setProgressDetails,
    showProgress,
    hideProgress,
  }), [
    progressVisible,
    progressMessage,
    progressDetails,
    showProgress,
    hideProgress,
  ]);

  return (
    <ProgressContext.Provider value={value}>
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error('useProgress must be used within ProgressProvider');
  }
  return context;
};

export default ProgressContext;
